import { useQuery } from 'react-query';
import { useCurrentUser } from '@qualio/ui-components';
import approversApi from '../api/approvers.api';

export const useEventFormApprovers = (formId: number) => {
  const { companyId } = useCurrentUser();

  return useQuery(['approversList', companyId, formId], () =>
    approversApi.getApprovers(companyId, formId, 'approvers'),
  );
};
